export default __webpack_public_path__ + "static/media/march-2018.ddbcfa31.csv";